import React from 'react'
import ProjectCard from './ProjectCard'

class ProjectsLayout extends React.Component{
  constructor(props){
    super(props)
  }

  render(){
    let pairs = []

    for (let i=0; i<this.props.projectsData.length; i+=2){
      pairs.push(this.props.projectsData.slice(i, i+2))
    }

    let projects = pairs.map((d, i)=>{
        return( 
          <div key={`plr${i}`} className="row">
              {d.map((p, i)=>{
                return( 
                  <div key={`pld${i}`} className="col s12 m6">
                    <ProjectCard key={`pc${i}`} img={p.img} projectTitle={p.projectTitle} projectDescription={p.projectDescription} link={p.link} screenshots={p.screenshots} source={p.source}/>
                  </div>
                )
              })}
          </div>
        )

    })

    return (<div>{projects}</div>)
  }
}



export default ProjectsLayout


// WEBPACK FOOTER //
// ./app/components/ProjectsLayout.js